<template>
  <main class="legal-page">
    <article class="legal-content">
      <router-link class="back-link" to="/">← Retour à l'accueil</router-link>

      <h1>MENTIONS LÉGALES</h1>

      <section>
        <h2>Éditeur du site</h2>
        <p>Le site fidmarket.fr est édité par :</p>
        <p>
          Matéo DAVENEAU, entrepreneur individuel (EI)<br>
          2 rue Raymond et Lucie Aubrac, 34560 Poussan, France<br>
          SIRET : [SIRET]<br>
          Email : <a href="mailto:contact@fidmarket.fr">contact@fidmarket.fr</a><br>
          Directeur de la publication : Matéo Daveneau<br>
          TVA non applicable, article 293 B du CGI.
        </p>
      </section>

      <section>
        <h2>Hébergement</h2>
        <p>Le site est hébergé par :</p>
        <p>
          Hetzner Online GmbH<br>
          Industriestr. 25, 91710 Gunzenhausen, Allemagne<br>
          Tél. : +49 (0)9831 505-0 — www.hetzner.com
        </p>
      </section>

      <section>
        <h2>Propriété intellectuelle</h2>
        <p>
          L'ensemble des éléments du site fidmarket.fr (textes, graphismes, logo,
          interface, structure) est la propriété exclusive de l'éditeur, sauf
          mention contraire. Toute reproduction, représentation ou exploitation,
          totale ou partielle, sans autorisation écrite préalable est interdite et
          constituerait une contrefaçon au sens des articles L.335-2 et suivants
          du Code de la propriété intellectuelle.
        </p>
      </section>

      <section>
        <h2>Données personnelles</h2>
        <p>
          Les données personnelles collectées via le site et l'application
          FIDmarket sont traitées conformément au Règlement général sur la
          protection des données (RGPD) et à la loi Informatique et Libertés.
          Les données sont hébergées au sein de l'Union européenne (Allemagne).
          Vous pouvez exercer vos droits d'accès, de rectification, d'effacement
          et d'opposition en écrivant à
          <a href="mailto:contact@fidmarket.fr">contact@fidmarket.fr</a>.
        </p>
      </section>

      <section>
        <h2>Cookies</h2>
        <p>
          Le site utilise uniquement des cookies et stockages locaux strictement
          nécessaires à son fonctionnement (authentification, préférences de
          session). Ces éléments ne nécessitent pas de consentement préalable et
          ne sont pas utilisés à des fins publicitaires.
        </p>
      </section>

      <section>
        <h2>Droit applicable</h2>
        <p>
          Les présentes mentions légales sont soumises au droit français. En cas
          de litige, et à défaut de résolution amiable, les tribunaux français
          seront compétents.
        </p>
      </section>
    </article>
  </main>
</template>

<script>
export default {
  name: 'MentionsLegales'
}
</script>

<style scoped>
.legal-page {
  --cream: #F5EDD6;
  --forest: #1A3A2A;
  min-height: 100vh;
  background: var(--cream);
  padding: clamp(28px, 6vw, 72px) clamp(18px, 5vw, 40px);
}

.legal-content {
  width: 100%;
  max-width: 760px;
  margin: 0 auto;
}

.back-link {
  display: inline-block;
  margin-bottom: clamp(36px, 7vw, 64px);
  color: var(--forest);
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
}

.back-link:hover {
  text-decoration: underline;
}

h1,
h2 {
  color: var(--forest);
}

h1 {
  margin: 0 0 clamp(36px, 7vw, 56px);
  font-size: clamp(30px, 6vw, 48px);
  letter-spacing: 0.04em;
}

section {
  margin-bottom: 34px;
}

h2 {
  margin: 0 0 12px;
  font-size: clamp(20px, 4vw, 25px);
}

p {
  margin: 0 0 12px;
  color: #33483c;
  font-size: clamp(15px, 2.5vw, 17px);
  line-height: 1.75;
}

@media (max-width: 480px) {
  .legal-page {
    padding-top: 24px;
  }

  section {
    margin-bottom: 28px;
  }
}
</style>
